import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/api/api";
import createVentReducer from "./slices/form/createVent";
import createGuestReducer from "./slices/form/createGuest";
import ventConfigTabReducer from "./slices/form/ventConfigTab";
import guestTabReducer from "./slices/form/guestTab";
import createActivityReducer from "./slices/form/createActivity";
import activityTabReducer from "./slices/form/activityTab";
import loginFormReducer from "./slices/form/login";
import upsertAssignmentReducer from "./slices/form/upsertAssignment";
import registerFormReducer from "./slices/form/register";
import emailLoginCompletionFormReducer from "./slices/form/emailLoginCompletion";
import passwordReducer from "./slices/form/password";
import guestsTabReducer from "./slices/form/guestsTab";
import createEmailTemplateReducer from "./slices/form/createEmailTemplate";
import emailTemplateTabReducer from "./slices/form/emailTemplateTab";
import sendEmailReducer from "./slices/form/emailGuests";
import uploadGuestsReducer from "./slices/form/uploadGuests";
import editHostReducer from "./slices/form/editHost";
import createHostReducer from "./slices/form/createHost";
import ventsTabReducer from "./slices/form/ventsTab";
import deleteVentReducer from "./slices/form/deleteVent";
import cloneVentReducer from "./slices/form/cloneVent";
import loginWithPasswordFormReducer from "./slices/form/loginWithPassword";
import createCustomFieldReducer from "./slices/form/createCustomField";
import customTextFieldTabReducer from "./slices/form/customTextFieldTab";
import customOptionsFieldTabReducer from "./slices/form/customOptionsFieldTab";
import emailTemplateSchedulerReducer from "./slices/form/emailTemplateScheduler";
import usersTabReducer from "./slices/form/usersTab";
import userTabReducer from "./slices/form/userTab";
import sendGuestMessageReducer from "./slices/form/sendGuestMessage";
import connectGuestFormReducer from "./slices/form/connectGuest";
import sendHostMessageFormReducer from "./slices/form/sendHostMessage";
import userAttributesTabReducer from "./slices/form/userAttributesTab";

export const store = configureStore({
  reducer: {
    ventConfigTab: ventConfigTabReducer,
    guestTab: guestTabReducer,
    createVentForm: createVentReducer,
    createGuestForm: createGuestReducer,
    createActivityForm: createActivityReducer,
    activityTab: activityTabReducer,
    loginForm: loginFormReducer,
    loginWithPasswordForm: loginWithPasswordFormReducer,
    registerForm: registerFormReducer,
    emailCompletionForm: emailLoginCompletionFormReducer,
    upsertAssignmentForm: upsertAssignmentReducer,
    userAttributesTab: userAttributesTabReducer,
    passwordForm: passwordReducer,
    guestsTab: guestsTabReducer,
    createEmailTemplateForm: createEmailTemplateReducer,
    emailTemplateTab: emailTemplateTabReducer,
    sendEmailForm: sendEmailReducer,
    uploadGuestsForm: uploadGuestsReducer,
    editHostForm: editHostReducer,
    createHostForm: createHostReducer,
    ventsTab: ventsTabReducer,
    deleteVentForm: deleteVentReducer,
    cloneVentForm: cloneVentReducer,
    createCustomFieldForm: createCustomFieldReducer,
    customTextFieldTab: customTextFieldTabReducer,
    customOptionsFieldTab: customOptionsFieldTabReducer,
    emailTemplateScheduler: emailTemplateSchedulerReducer,
    usersTab: usersTabReducer,
    userTab: userTabReducer,
    sendGuestMessageForm: sendGuestMessageReducer,
    connectGuestForm: connectGuestFormReducer,
    sendHostMessageForm: sendHostMessageFormReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
